module.exports = __webpack_public_path__ + "img/vegas.0a9c2dc0.png";